// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-toggle-group-control.softlite-toggle-control{
    border: 1px solid #d6cfcf;
}
.components-toggle-group-control.softlite-toggle-control .softlite-toggle-control__button {
    border-right: 1px solid #d6cfcf;
}
.softlite-display-label-block{
    margin-top: 10px;
    margin-bottom: 15px !important;
}
.softlite-display-label-block label, .softlite-toggle span.components-base-control__label{
    font-weight: 400;
    font-size: 13px;
    text-transform: capitalize;
}
.softlite-toggle .components-base-control{
    margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/display/display.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;AACnC;AACA;IACI,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".components-toggle-group-control.softlite-toggle-control{\r\n    border: 1px solid #d6cfcf;\r\n}\r\n.components-toggle-group-control.softlite-toggle-control .softlite-toggle-control__button {\r\n    border-right: 1px solid #d6cfcf;\r\n}\r\n.softlite-display-label-block{\r\n    margin-top: 10px;\r\n    margin-bottom: 15px !important;\r\n}\r\n.softlite-display-label-block label, .softlite-toggle span.components-base-control__label{\r\n    font-weight: 400;\r\n    font-size: 13px;\r\n    text-transform: capitalize;\r\n}\r\n.softlite-toggle .components-base-control{\r\n    margin-bottom: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
